// Hosted application logic, deliberately absent from the Chrome extension.
// New text formats can be supported here with a normal Get deployment.
export function withoutCalendarLinks(text:string){
 return text.replace(/https:\/\/(?:calendar\.google\.com|www\.google\.com\/calendar)\/[^\s]+/gi,'')
  .replace(/^\s*(?:Afegir al calendari|Añadir al calendario|Agregar al calendario|Add to calendar)\s*:\s*$/gim,'').trim();
}
export function recognizeWakymaShare(d:any){
 const text=withoutCalendarLinks(d.text);
 const base={phone:d.phone,at:d.at};
 if(d.context?.type==='appointment'){
  const c=d.context;
  return {...base,kind:'reminder',pet:c.pet,petId:c.petId,clientId:c.clientId,date:c.date,time:c.time,vet:c.vet};
 }
 const links=text.match(/https:\/\/vets\.wakyma\.com\/[^\s]+/g)||[];
 if(links.length===1){
  const documentUrl=links[0];let u;try{u=new URL(documentUrl);}catch{return null;}
  if(u.origin==='https://vets.wakyma.com'&&u.pathname==='/compartir/informe-visita/'&&!u.hash&&!u.username&&!u.password&&u.searchParams.getAll('appointmentId').length===1&&/^[A-Za-z0-9]{5,40}$/.test(u.searchParams.get('appointmentId')||'')&&u.searchParams.getAll('accessToken').length===1&&!!u.searchParams.get('accessToken')&&[...u.searchParams.keys()].every(k=>['appointmentId','accessToken'].includes(k)))return {...base,kind:'visit',visitId:u.searchParams.get('appointmentId')};
  if(u.origin==='https://vets.wakyma.com'&&u.pathname==='/compartir/adjunto/'&&!u.hash&&u.searchParams.getAll('attachmentId').length===1&&/^[A-Za-z0-9]{5,40}$/.test(u.searchParams.get('attachmentId')||'')&&[...u.searchParams.keys()].every(k=>['attachmentId','accessToken'].includes(k)))return {...base,kind:'report',attachmentId:u.searchParams.get('attachmentId')};
  if(/^\/firmar\/[a-f0-9]{64}$/.test(u.pathname)&&!u.search)return {...base,kind:'signature',documentUrl};
  if(/^\/compartir\/(ticket|facturas-venta)\/$/.test(u.pathname)){
   const details=text.match(/Te dejamos (?:el ticket|la factura) de (.+?) en Cl[ií]nica Veterinaria Parc, del d[ií]a (\d{2}-\d{2}-\d{4})/i);
   if(details)return {...base,kind:'document',documentUrl,pet:details[1].trim(),date:details[2]};
  }
 }
 // Only explicit years: never guess an appointment date from a calendar link.
 if(/recordatori(?:o)?\s+(?:de\s+)?(?:una\s+)?cita/i.test(text)){
  const date=text.match(/(?:Fecha|Data):\s*(\d{2}-\d{2}-\d{4})/i)?.[1];
  const time=text.match(/Hora:\s*(\d{1,2}):([0-5]\d)/i);
  const pet=text.match(/Mascota:\s*([^\r\n]+)/i)?.[1]?.trim();
  if(date&&time&&pet)return {...base,kind:'reminder',pet,date,time:time[1].padStart(2,'0')+':'+time[2],vet:''};
 }
 return null;
}
